module.exports = __webpack_public_path__ + "img/GR087.c2c66b42.png";